import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'arCode',
    detailUrl: '/AmArDetail',
    detailIdProp: 'arId',
    listUrl: '/AmArList',
    mapProp: 'arMap',
    name: '分析报表',
    textProp: 'arName',
    type: 'AMAR',
}
